module.exports = __webpack_public_path__ + "media/pantera-walk.c57f4e9a.mp3";